import { useSyncExternalStore } from "react";

export type Workspace = "design" | "execution";

export const WORKSPACE_HEADER = "X-Pm-Workspace";

const STORAGE_KEY = "pm.workspace";

const listeners = new Set<() => void>();

function stored(): Workspace {
    try {
        return window.localStorage.getItem(STORAGE_KEY) === "design" ? "design" : "execution";
    } catch {
        return "execution";
    }
}

function persist(value: Workspace) {
    try {
        window.localStorage.setItem(STORAGE_KEY, value);
    } catch {
        return;
    }
}

let current: Workspace = stored();

export function getWorkspace(): Workspace {
    return current;
}

export function setWorkspace(next: Workspace) {
    if (next === current) {
        return;
    }
    current = next;
    persist(next);
    listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

export function useWorkspace(): Workspace {
    return useSyncExternalStore(subscribe, getWorkspace);
}
